module.exports = __webpack_public_path__ + "static/media/Friday.c498d654.webp";